import ClayModal from "@clayui/modal";
import React from "react";

import { LANGUAGE } from "../../constants/constant";
import { properties } from "../../util/Properties";
import { getLanguage } from "../../util/UtilMethods";
import CloseButton from "../common/CloseButton";
import ChatModalBody from "./ChatModalBody";

const ChatModal = (props) => {
  const { onClose, observer } = props;

  return (
    <ClayModal
      id="chatApp"
      size="default"
      className={`modal-height-xl modal-dialog-right ${
        LANGUAGE.ENGLISH === getLanguage() ? "ltr" : "rtl"
      }`}
      observer={observer}
      spritemap={properties.icons}
    >
      <ClayModal.Body className="inline-scroller chat-modal" id="liveChatModal">
        <CloseButton onClose={onClose} />
        <ChatModalBody />
      </ClayModal.Body>
    </ClayModal>
  );
};

export default ChatModal;
